<div class="order-contact-confirmation">
  @if (formData(); as formData) {
    @if(case(); as caseDto) {
      <div class="row">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>{{ 'order-contact.order-contact-confirmation.case-number' | translate }}</mat-label>
          <input matInput readonly="readonly" [value]="('currency' | translate: { amount: caseDto.balance | number: '1.2-2' : 'fr-FR'}) + ' ' + caseDto.presentCreditorShortName">
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>{{ 'order-contact.order-contact-confirmation.phone-number' | translate }}</mat-label>
          <input matInput readonly="readonly" [value]="formData.phoneNumber.phone">
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field class="example-full-width"  appearance="outline">
          <mat-label>{{ 'order-contact.order-contact-confirmation.date-and-hour' | translate }}</mat-label>
          <input matInput readonly="readonly" [value]="dateString()">
        </mat-form-field>
      </div>
    }
  }
</div>